const Header = (props) => {
  return (
    <div className="text-xs font-semibold text-center leading-tight px-2 whitespace-nowrap">
      {props?.colDef?.headerName}
    </div>
  );
};

export default Header;
